import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "w-full h-full",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M17.038 1.42a2.8 2.8 0 0 1 1.924 0c.53.193.93.588 1.293 1.055l2.566 4.076c.29.58.492 1.16.411 1.762a2.81 2.81 0 0 1-.98 1.78c-.466.39-1.065.529-1.71.593h-5.084c-.645-.064-1.244-.203-1.71-.593a2.8 2.8 0 0 1-.98-1.78c-.081-.602.121-1.183.411-1.762l2.566-4.076c.364-.467.763-.862 1.293-1.055",
      opacity: ".4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      d: "M8.528 1.309c.553.06 1.055.19 1.496.51.252.183.474.405.658.657.32.442.45.943.51 1.497V8.03c-.06.553-.19 1.055-.51 1.496a3 3 0 0 1-.658.658c-.441.32-.943.45-1.496.51H4.47c-.554-.06-1.055-.19-1.497-.51a3 3 0 0 1-.657-.658c-.32-.441-.45-.943-.51-1.496V3.973c.06-.554.19-1.055.51-1.497.183-.252.405-.474.657-.657.442-.32.943-.45 1.497-.51z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      "fill-rule": "evenodd",
      d: "M13.25 18a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      "fill-rule": "evenodd",
      d: "M2.293 13.793a1 1 0 0 1 1.414 0L6.5 16.586l2.793-2.793a1 1 0 0 1 1.414 1.414L7.914 18l2.793 2.793a1 1 0 0 1-1.414 1.414L6.5 19.414l-2.793 2.793a1 1 0 0 1-1.414-1.414L5.086 18l-2.793-2.793a1 1 0 0 1 0-1.414",
      "clip-rule": "evenodd",
      opacity: ".4"
    }, null, -1)
  ])))
}
export default { render: render }